var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Iframe',{staticClass:"fill-height fill-width",attrs:{"link":"https://mpctv.fr/imJbk","title":"Menu"}})}
var staticRenderFns = []

export { render, staticRenderFns }